(function(){
  function configureCustomsCtas(){
    var secondary=document.querySelector('.cs-cta-group .cs-btn-secondary');
    if(secondary){
      secondary.textContent='Talk With Us First';
      secondary.setAttribute('href','/pages/contact');
    }
  }

  function initCustomOrderForm(){
    configureCustomsCtas();

    var form=document.getElementById('cs-custom-order-form');
    if(!form || form.dataset.csValidationReady==='true') return;
    form.dataset.csValidationReady='true';

    var errorBox=document.getElementById('cs-form-error');
    var successBox=document.getElementById('cs-form-success');
    var button=document.getElementById('cs-submit-button');
    var fields=[
      {el:document.getElementById('ContactForm-name'),err:document.getElementById('error-name'),test:function(v){return v.trim().length>=2;}},
      {el:document.getElementById('ContactForm-email'),err:document.getElementById('error-email'),test:function(v){return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim());}},
      {el:document.getElementById('ContactForm-body'),err:document.getElementById('error-body'),test:function(v){return v.trim().length>=20;}}
    ];

    function setInvalid(item,bad){
      if(!item.el || !item.err) return;
      item.el.classList.toggle('cs-invalid',bad);
      item.err.classList.toggle('is-visible',bad);
      item.el.setAttribute('aria-invalid',bad?'true':'false');
    }

    fields.forEach(function(item){
      if(!item.el) return;
      item.el.addEventListener('input',function(){
        if(item.test(item.el.value)) setInvalid(item,false);
      });
      item.el.addEventListener('blur',function(){
        setInvalid(item,!item.test(item.el.value));
      });
    });

    form.addEventListener('submit',function(e){
      var first=null;
      fields.forEach(function(item){
        if(!item.el) return;
        var bad=!item.test(item.el.value);
        setInvalid(item,bad);
        if(bad&&!first) first=item.el;
      });
      if(first){
        e.preventDefault();
        if(successBox) successBox.classList.remove('is-visible');
        if(errorBox){
          errorBox.classList.add('is-visible');
          errorBox.focus();
          errorBox.scrollIntoView({behavior:'smooth',block:'center'});
        }
        setTimeout(function(){first.focus();},350);
        return;
      }
      if(errorBox) errorBox.classList.remove('is-visible');
      if(button){button.disabled=true;button.textContent='Submitting…';}
    });

    var params=new URLSearchParams(window.location.search);
    if(params.get('contact_posted')==='true'){
      form.reset();
      fields.forEach(function(item){setInvalid(item,false);});
      if(errorBox) errorBox.classList.remove('is-visible');
      if(successBox){
        successBox.classList.add('is-visible');
        successBox.focus();
        successBox.scrollIntoView({behavior:'smooth',block:'center'});
      }
      if(button){button.disabled=false;button.textContent='Submit Request';}
      if(history.replaceState){history.replaceState({},document.title,window.location.pathname+'#customs-form');}
    }
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initCustomOrderForm,{once:true});
  }else{
    initCustomOrderForm();
  }
  document.addEventListener('shopify:section:load',initCustomOrderForm);
})();